import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { memo } from 'react';

import { RegistrationStatusLabel } from '@/components/RegisterAuctionBanner/RegistrationStatusLabel';
import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryCatalogId,
    getItemSummaryCatalogTitle,
    getItemSummaryStartTime,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { longFormatDate } from '@/utils/dates';
import { getCatalogUrl } from '@/utils/urls';

type Props = {
    itemId: number;
    openOnBlank?: boolean;
};

const linkClass = 'font-secondary leading-6 text-text-primary no-underline';

const AuctionInfoComponent = ({ itemId, openOnBlank = false }: Props) => {
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const catalogTitle = useAppSelector((state) => getItemSummaryCatalogTitle(state, itemId));
    const saleStartTs = useAppSelector((state) => getItemSummaryStartTime(state, itemId));

    return (
        <>
            {openOnBlank ? (
                <Link
                    className={linkClass}
                    href={getCatalogUrl(catalogId, catalogTitle)}
                    target="_blank"
                >
                    {catalogTitle}
                </Link>
            ) : (
                <RouteLink
                    className={linkClass}
                    to={getCatalogUrl(catalogId, catalogTitle)}
                >
                    {catalogTitle}
                </RouteLink>
            )}
            <div>
                <BodySecondary className="leading-6">{longFormatDate(saleStartTs)}</BodySecondary>
            </div>
            <div>
                <RegistrationStatusLabel
                    catalogId={catalogId}
                    itemId={itemId}
                    justify
                    showRegister={false}
                />
            </div>
        </>
    );
};

export const AuctionInfo = memo<Props>(AuctionInfoComponent);
